<mat-toolbar #pickingCompletePanel [style.display]="allChecked ? 'flex' : 'none'" role="toolbar"
    style="font-size: 14px; background-color:transparent; padding: 0 5px;">
    <span style="line-height:1.1em;">Item Pull Complete</span>
    <span style="flex: 1 1 auto;"></span>
    <button mat-raised-button color="primary" (click)="completeCutHoldPull()">
        <mat-icon>shop</mat-icon> Complete Pull
    </button>
</mat-toolbar>

<table mat-table *ngIf="shipment" [dataSource]="this.shipmentPieces" style="width:100%;">
    <ng-container matColumnDef="checked">
        <th mat-header-cell *matHeaderCellDef><mat-icon>check</mat-icon></th>
        <td mat-cell *matCellDef="let piece" style="padding-left:0;">
            <!-- <span *ngIf="piece.checked"><mat-icon>check</mat-icon></span> -->
            <button mat-button (click)="piece.checked = !piece.checked">
                <mat-icon *ngIf="piece.checked">check_box</mat-icon>
                <mat-icon *ngIf="!piece.checked">check_box_outline_blank</mat-icon>
            </button>
        </td>
    </ng-container>

    <ng-container matColumnDef="thumbnail">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let piece"><item-thumbnail [item]="stockItems[piece.InventoryID]"></item-thumbnail>
        </td>
    </ng-container>

    <ng-container matColumnDef="Item">
        <th mat-header-cell *matHeaderCellDef>Item</th>
        <td mat-cell *matCellDef="let piece">
            <span [innerHTML]="piece.InventoryID"></span><br />
            <span [innerHTML]="piece.LotSerialNbr | wrapRight"></span>
        </td>
    </ng-container>

    <ng-container matColumnDef="Qty">
        <th mat-header-cell *matHeaderCellDef>Qty</th>
        <td mat-cell *matCellDef="let piece">{{piece.Qty}} {{piece.UOM}}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="shipmentPieceTableColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: shipmentPieceTableColumns;"></tr>
</table>

<ng-template #releasingFromHoldIndicator>
    <mat-spinner diameter="30" style="display:inline-block;"></mat-spinner> Item &amp; Inventory
    loading...
</ng-template>